// Finder-style columns retain parent listings while the active directory changes.
export default {
 data:()=>({columns:[],columnGeneration:0,columnSignature:'',columnSelection:null}),
 watch:{ownerId(){this.resetColumns()}},
 beforeDestroy(){this.columnGeneration++},
 methods:{
  resetColumns(){this.columnGeneration++;this.columns=[];this.columnSignature='';this.columnSelection=null},
  async syncColumns(force=false){
   if(this.viewMode!=='columns')return
   const generation=++this.columnGeneration,tree=this.mode==='files'&&!this.keyword
   const signature=JSON.stringify([this.ownerId,this.space.ownerId,this.mode,this.keyword,this.tagId,this.sort])
   const previous=this.columns,retained=signature===this.columnSignature?previous:[]
   const path=tree?[{id:0,name:'全部文件'},...this.trail]:[{id:this.parentId,name:this.keyword?'搜索结果':this.mode==='trash'?'回收站':'智能分类'}]
   const last=path.length-1,columns=path.map((folder,index)=>{
    const cached=retained.find(column=>String(column.parentId)===String(folder.id))
    return {parentId:folder.id,name:folder.name,selectedId:index<last?path[index+1].id:null,rows:cached?cached.rows:[],page:cached?cached.page:1,total:cached?cached.total:0,loading:force||!cached||cached.loading||!!cached.error,error:'',tree,requestGeneration:0}
   })
   Object.assign(columns[last],{rows:this.rows,page:this.page,total:this.total,loading:false})
   this.columns=columns;this.columnSignature=signature
   if(!this.columnSelection||String(this.columnSelection.parentId)!==String(this.parentId))this.columnSelection=null
   await Promise.all(columns.slice(0,last).filter(column=>column.loading).map(column=>this.fetchColumn(column,generation)))
   if(generation!==this.columnGeneration||this.disposed)return
   if(previous.length!==columns.length||!previous[last]||String(previous[last].parentId)!==String(this.parentId))this.$nextTick(()=>{
    const element=this.$refs.columns;if(element)element.scrollLeft=element.scrollWidth
   })
  },
  async fetchColumn(column,generation=this.columnGeneration){
   const requestGeneration=++column.requestGeneration,current=()=>generation===this.columnGeneration&&requestGeneration===column.requestGeneration&&!this.disposed
   column.loading=true;column.error=''
   try{
    const list=await this.request('/nodes',{parentId:column.parentId,status:'ACTIVE',sort:this.sort,page:column.page,size:50})
    if(!current())return
    column.rows=list.records;column.total=list.total
   }catch(error){if(current()){column.rows=[];column.error=error.message||'加载失败'}}
   finally{if(current())column.loading=false}
  },
  columnRows(column){
   if(!column.tree)return column.rows
   const pending=(this.mapping.working||[]).filter(item=>!item.id&&String(item.parentId||0)===String(column.parentId)&&!column.rows.some(row=>row.name===item.name)).map(item=>({id:'pending-'+item.path,parentId:column.parentId,name:item.name,kind:item.kind||'FILE',pending:true,tags:[],fileSize:0}))
   return column.rows.concat(pending)
  },
  columnSelected(column,row){return String(column.selectedId)===String(row.id)||!!(this.columnSelection&&String(this.columnSelection.parentId)===String(column.parentId)&&String(this.columnSelection.id)===String(row.id))},
  chooseColumnRow(column,row){
   if(row.pending||Date.now()<(this.suppressOpenUntil||0)||this.mode==='trash')return
   this.columnSelection={parentId:column.parentId,id:row.id}
   if(row.kind!=='DIR'&&column.tree&&String(column.parentId)!==String(this.parentId)){this.parentId=column.parentId;this.page=column.page;this.load()}
   this.openItem(row)
  },
  async changeColumnPage(column,page){
   if(String(column.parentId)===String(this.parentId)){this.page=page;await this.load()}
   else{column.page=page;await this.fetchColumn(column)}
  }
 }
}
